import { LocationTypeEnum } from '@app/enums/location-type.enum';

export const MAX_AMENITY_COUNT = 5;
export const VISIBLE_PRICING_VARIANTS = 3;
export const TRACE_HEADER_NAME = 'uber-trace-id';
export const MAX_VISIBLE_FILTERS = 7;
export const REVIEWS_MIN_QUERY_LENGTH = 2;
export const REVIEW_ITEM_DEFAULT_LINE_HEIGHT = 3;

export const PAGINATION_CONSTS = {
    MAX_VISIBLE_PAGES: 5,
};

export const SEARCH_CONSTS = {
    LOCATION: 'Polska',
    GEO_ID: '1',
    LOCATION_TYPE: LocationTypeEnum.Country,
    PAGE_ITEM_COUNT: 30,
};

export const MAP_DEFAULTS = {
    ZOOM: 12,
    MAX_ZOOM: 20,
    MIN_ZOOM: 7,
    BRANCHING: 2,
    MANUAL_ZOOM_THRESHOLD: 13,
    LOCATION: SEARCH_CONSTS.LOCATION,
    GEO_ID: SEARCH_CONSTS.GEO_ID,
    LOCATION_TYPE: SEARCH_CONSTS.LOCATION_TYPE,
    RADIUS: 10000,
    MAX_IMAGES_COUNT: 10,
    POPOVER: {
        OFFSET_Y_DEFAULT: -50,
        OFFSET_Y_TOP: 20,
        UI_OFFSET: 195,
        WIDTH: 300,
        HEIGHT: 260,
        MARGIN: 10,
    },
    BATCH_SIZE: 35,
};
